export const themeSliceName = "theme";
